var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgLetter = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1688 1.79237H1.83426C0.822471 1.79237 0 2.61484 0 3.62663V11.3734C0 12.3852 0.822471 13.2076 1.83426 13.2076H13.1657C14.1775 13.2076 15 12.3852 15 11.3734V3.62973C15.0031 2.61794 14.1806 1.79237 13.1688 1.79237ZM14.1651 11.3734C14.1651 11.9227 13.7182 12.3696 13.1688 12.3696H1.83426C1.28492 12.3696 0.837989 11.9227 0.837989 11.3734V3.62973C0.837989 3.08039 1.28492 2.63346 1.83426 2.63346H13.1657C13.7151 2.63346 14.162 3.08039 14.162 3.62973V11.3734H14.1651Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.45994 7.40379L13.1285 4.11391C13.2992 3.95872 13.3147 3.69491 13.1595 3.52111C13.0043 3.3504 12.7405 3.33489 12.5667 3.49007L7.50774 8.03073L6.52078 7.14929C6.51767 7.14618 6.51457 7.14308 6.51457 7.13998C6.49284 7.11825 6.47112 7.09963 6.44629 7.08101L2.43015 3.48697C2.25634 3.33178 1.99253 3.3473 1.83735 3.52111C1.68217 3.69491 1.69768 3.95872 1.87149 4.11391L5.58347 7.43172L1.88701 10.8923C1.71941 11.0506 1.7101 11.3144 1.86839 11.4851C1.95218 11.572 2.06392 11.6186 2.17565 11.6186C2.27807 11.6186 2.38049 11.5813 2.46119 11.5068L6.21351 7.99659L7.23151 8.90596C7.31221 8.97734 7.41153 9.01149 7.51084 9.01149C7.61016 9.01149 7.71258 8.97424 7.79017 8.90286L8.83611 7.96555L12.5667 11.5099C12.6474 11.5875 12.7529 11.6248 12.8554 11.6248C12.9671 11.6248 13.0757 11.5813 13.1595 11.4944C13.3178 11.3268 13.3116 11.0599 13.144 10.9016L9.45994 7.40379Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLetter, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/letter.abbce671.svg";
export { ForwardRef as ReactComponent };